import React, { useCallback } from 'react'
import { cnpjMask, phoneMask } from '../organisms/profile/helpers'
import {
  StyledFormGroup,
  StyledLabel,
  StyledInput,
  StyledError,
  StyledOptionalText,
} from './styles/PreSignupForm.style'

interface IPreSignupFormInputs {
  firstName: string
  lastName: string
  phone: string
  cnpj: string
  businessType: string
}

interface SignupTextInputProps {
  label: string
  name: keyof IPreSignupFormInputs
  value: string
  isOptional?: boolean
  isPhone?: boolean
  isCNPJ?: boolean
  error?: string
  placeholder?: string
  onChange: (name: keyof IPreSignupFormInputs, value: string) => void
}

export const SignupTextInput = ({
  label,
  name,
  value,
  isOptional,
  isPhone,
  isCNPJ,
  error,
  placeholder,
  onChange,
}: SignupTextInputProps) => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      let newValue = event.target.value
      if (isPhone) {
        newValue = phoneMask(newValue)
      } else if (isCNPJ) {
        newValue = cnpjMask(newValue)
      }
      onChange(name, newValue)
    },
    [isPhone, isCNPJ, name, onChange]
  )

  const inputType = isPhone ? 'tel' : 'text'
  const maxLength = isPhone ? 15 : 500

  return (
    <StyledFormGroup>
      <StyledLabel>
        {label}
        {isOptional && <StyledOptionalText> (Opcional)</StyledOptionalText>}
      </StyledLabel>
      <StyledInput
        name={name}
        type={inputType}
        value={value}
        onChange={handleChange}
        maxLength={maxLength}
        placeholder={placeholder || ''}
        requiredEmpty={!!error}
      />
      {error && <StyledError>{error}</StyledError>}
    </StyledFormGroup>
  )
}
